import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { Fade } from '@material-ui/core'

import GridContainer from 'components/Grid/GridContainer'
import GridItem from 'components/Grid/GridItem'
import Button from 'components/CustomButtons/Button.jsx'

import {
    ModalContainer,
    PaperContainer,
    SectionText,
    Title,
    TitleTxt,
} from './styles'
import { IconInfor } from '../../../../assets/icons_svg'
import { Stack, Typography } from '@mui/material'

function ModalDateOfBirthError({
    t,
    className,
    closeByClick,
    maxWidth,
    minWidth,
    open,
    padding,
    shadow,
    title,
    text,
    preDisabled,
    contact,
    themeColor,
    handleResetDate,
}) {
    return (
        <ModalContainer
            open={open}
            className={className}
            onClose={closeByClick}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            shadow={shadow}
            maxwidth={maxWidth}
            minwidth={minWidth}
            disableEnforceFocus
            style={{
                backdropFilter: 'blur(4px)',
            }}
        >
            <Fade in={open} unmountOnExit>
                <PaperContainer
                    padding={padding}
                    maxwidth={maxWidth}
                    preDisabled={preDisabled}
                >
                    <GridContainer xs={12} sm={12} style={{ padding: '25px' }}>
                        <GridItem
                            xs={12}
                            sm={12}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '20px',
                            }}
                        >
                            <IconInfor
                                sx={{
                                    pb: '16px',
                                    fontSize: '90px !important',
                                    color:
                                        themeColor?.visual?.icons?.color ||
                                        '#eea236',
                                }}
                            />
                            <Title>{t('Atenção!')}</Title>
                        </GridItem>
                        <GridItem
                            xs={12}
                            sm={12}
                            style={{
                                textAlign: 'center',
                                marginTop: '17px',
                            }}
                        >
                            <SectionText>{t(text)}</SectionText>
                        </GridItem>{' '}
                        {!preDisabled && (
                            <GridItem
                                xs={12}
                                sm={12}
                                style={{ textAlign: 'center' }}
                            >
                                <TitleTxt>{t(title)}</TitleTxt>
                                <Stack spacing={0.5}>
                                    <Typography
                                        variant="body2"
                                        fontSize="13px"
                                        color="#9B9B9B"
                                    >
                                        {t('IF_IN_DOUBT_CONTACT_SUPPORT')}
                                    </Typography>

                                    <Typography
                                        variant="body2"
                                        fontSize="13px"
                                        sx={{
                                            color: themeColor?.navigation
                                                ?.buttons?.backgroundColor,
                                        }}
                                    >
                                        E-mail: {contact?.contactEmail || ''}
                                    </Typography>

                                    <Typography
                                        variant="body2"
                                        fontSize="13px"
                                        sx={{
                                            color: themeColor?.navigation
                                                ?.buttons?.backgroundColor,
                                        }}
                                    >
                                        {t('FIELD_REGISTER_PHONE')}:{' '}
                                        {contact?.contactPhoneNumber || '-'}
                                    </Typography>
                                </Stack>
                            </GridItem>
                        )}
                        <GridItem
                            xs={12}
                            sm={12}
                            style={{ textAlign: 'center', marginTop: '5px' }}
                        >
                            <Button
                                size="sm"
                                variant="contained"
                                color={'greenButtonColor'}
                                onClick={handleResetDate}
                                style={{
                                    width: '100px',
                                }}
                            >
                                {t('Ok')}
                            </Button>
                        </GridItem>
                    </GridContainer>
                </PaperContainer>
            </Fade>
        </ModalContainer>
    )
}

ModalDateOfBirthError.propTypes = {
    children: PropTypes.element,
    className: PropTypes.string,
    closeByClick: PropTypes.func,
    showButtons: PropTypes.bool,
    handleClose: PropTypes.func,
    handleForgetPWD: PropTypes.func,
    handleLogin: PropTypes.func,
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    open: PropTypes.bool,
    padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    shadow: PropTypes.string,
    text: PropTypes.string,
    preDisabled: PropTypes.bool,
    handleResetDate: PropTypes.func,
}

ModalDateOfBirthError.defaultProps = {
    children: null,
    className: '',
    closeByClick: null,
    handleClose: null,
    handleForgetPWD: null,
    handleLogin: null,
    maxWidth: '',
    minWidth: '',
    open: false,
    showButtons: true,
    padding: '',
    shadow: '',
    text: '',
    preDisabled: false,
}

export default withTranslation()(ModalDateOfBirthError)
